module.exports = __webpack_public_path__ + "7b1ac14615a02491c69df127ee4e183f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vectorBEER.jpg
// module id = 1040
// module chunks = 1